export const POSTAL_CODE_REGEX = /^\d{5}(-\d{4})?$/
export const PERSON_NAME_REGEX = /^[A-Za-z' .-]+$/

export const NON_DIGIT_REGEX = /[^0-9]/g
export const NON_DIGIT_OR_DASH_REGEX = /[^0-9-]/g
export const NON_UPPERCASE_LETTER_REGEX = /[^A-Z]/g
